import CheckboxSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/CheckboxSetting';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';

const FlipLayout = ({
  defaultAttributes,
  item,
  onChange,
}: ComponentSettingsTab<SectionItemAttributes>) => {
  const settingProps = { defaultAttributes, item };

  const handleChangeFlip = (props) => {
    item.children = item?.children?.reverse();
    onChange(props);
  };

  return (
    <CheckboxSetting
      onChange={handleChangeFlip}
      settingKey="flipLayout"
      title={__('Flip layout')}
      {...settingProps}
    />
  );
};

export default FlipLayout;
